<template>
  <div>
    <h2>Colegio de Procedencia</h2>
    <app-ubigeo
      ref="ubigeo"
      :regions="regions"
      :provinces="provinces"
      :districts="districts"
      @changed="ubigeoCambiado"
    />
    <v-layout>
      <v-flex
        sm12
        xs12
      >
        <v-autocomplete
          v-model="form.school_id"
          :items="schools"
          dense
          clearable
          small-chips
          :rules="rules.school_id"
          :error="!!formErrors.school_id"
          :error-messages="formErrors.school_id"
          label="NOMBRE DE LA INSTITUCIÓN EDUCATIVA"
          item-text="title"
          item-value="id"
          :disabled="loadingSchools || form.no_school"
        />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import AppUbigeo from './ubigeo'

export default {
  name: 'AppDatosColegio',
  components: { AppUbigeo },
  props: {
    regions: {
      required: true, type: Array
    },
    provinces: {
      required: true, type: Array
    },
    districts: {
      required: true, type: Array
    }
  },
  data () {
    return {
      schools: [],
      formErrors: {},
      form: {
        school_region: '',
        school_province: '',
        school_district_id: '',
        school_id: ''
      },
      rules: {
        school_id: [v => !!v || 'Se requiere los datos del colegio.']
      }
    }
  },
  computed: {
    ...mapState({
      loadingSchools: state => state.schools.loadingSchools
    }),
    validForm () {
      if (!this.form.school_region) {
        this.$message.warning('Debe seleccionar la región del colegio')
        return false
      }
      if (!this.form.school_province) {
        this.$message.warning('Debe seleccionar la provincia del colegio')
        return false
      }
      if (!this.form.school_district_id) {
        this.$message.warning('Debe seleccionar el distrito del colegio')
        return false
      }
      if (!this.form.school_id) {
        this.$message.warning('Debe seleccionar el colegio')
        return false
      }

      return true
    }
  },
  watch: {
    'form.school_region': function (val) {
      this.$refs.ubigeo.form.region = val
    },
    'form.school_province': function (val) {
      this.$refs.ubigeo.form.province = val
    },
    'form.school_district_id': function (val) {
      this.$refs.ubigeo.form.district = val
      this.loadSchools()
    },
    'form.school_id': function (val) {
    }
  },
  created () {
    /*
    this.$refs.ubigeo.region = this.form.school_region;
    this.$refs.ubigeo.province = this.form.school_province;
    this.$refs.ubigeo.district = this.form.school_district;
    this.form.school_id = this.form.school_id || ''; */
  },
  methods: {
    ...mapActions({
      replaceCurrentProduct: 'admision/replaceCurrentProduct',
      getSchools: 'schools/getSchools'
    }),
    ubigeoCambiado (ubigeo) {
      [this.form.school_region, this.form.school_province, this.form.school_district_id] =
        [ubigeo.region, ubigeo.province, ubigeo.district]

      this.loadSchools()
    },
    loadSchools () {
      if (!this.form.school_district_id) {
        this.schools = []
        return
      }

      this.getSchools({ id: this.form.school_district_id }).then(response => {
        this.schools = response.data.data
      })
    }
  }
}
</script>
